<template>
  <div>
    <v-dialog v-model="value" persistent max-width="400px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.firstName.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.first_name'
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="lastNameErrors"
                      v-model="$v.userForm.lastName.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.last_name'
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="emailErrors"
                      v-model="$v.userForm.mail.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.email'
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="close">
            {{
              $t(
                'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.cancel'
              )
            }}
          </v-btn>
          <v-btn color="primary darken-1" flat @click="submit">
            {{
              $t(
                'students.massive_upload.step_3.table.parent_detail.edit_parent_modal.save'
              )
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import ConfirmMail from '../Dialogs/ConfirmMails'
import editImage from '../Modals/EditImage'

export default {
  props: ['title', 'parent', 'value'],
  components: {
    editImage,
    ConfirmMail,
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email },
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.parent !== undefined) {
          this.userForm.id = this.parent.id
          this.userForm.firstName = this.parent.firstName
          this.userForm.lastName = this.parent.lastName
          this.userForm.mail = this.parent.mail
        }
      }
    },
  },
  mounted() {},
  data: () => ({
    userForm: {
      firstName: '',
      lastName: '',
      mail: '',
      pos: '',
    },
    userFormUp: {
      id: '',
      firstName: '',
      lastName: '',
      mail: '',
    },
    flags: {
      confirmMails: false,
    },
  }),
  methods: {
    submit() {
      this.$v.userForm.$touch()
      if (this.parent !== undefined) {
        if (!this.$v.userForm.$invalid) {
          this.$emit('updateParent', this.userForm)
          this.close()
        } else {
          console.log('Campos invalidos')
        }
      } else {
        if (!this.$v.userForm.$invalid) {
          this.$emit('createParent', this.userForm)
          this.close()
        } else {
          console.log('Campos invalidos')
        }
      }
    },
    close() {
      this.$v.$reset()
      this.userForm = {
        firstName: '',
        lastName: '',
        mail: '',
      }
      this.$emit('input', !this.value)
    },
  },
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.userForm.mail.$dirty) return errors
      !this.$v.userForm.mail.required && errors.push('Correo obligatorio')
      !this.$v.userForm.mail.email && errors.push('Correo inválido')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.userForm.lastName.$dirty) return errors
      !this.$v.userForm.lastName.required &&
        errors.push('Apellidos obligatorios')
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.userForm.firstName.$dirty) return errors
      !this.$v.userForm.firstName.required && errors.push('Nombre obligatorio')
      return errors
    },
  },
}
</script>
